import { motion } from "framer-motion";

interface StatCardProps {
  type: string;
  title: string;
  count: number;
  rate: number;
  change?: number;
  index?: number;
  length?: number;
  isFull?: boolean;
}

export function StatCard(props: StatCardProps) {
  const change = props.change ? (props.change > 0 ? "+" : "") + props.change : null;
  const isGreen = props.index === 0;
  const isMagenta = props.index === 1 && props.length === 3;
  const isGray = props.type === "default" || props.type === "national";

  return (
    <motion.div
      className={`${props.isFull ? "w-full basis-full" : ""} ${
        isGreen ? "bg-green" : isMagenta ? "bg-magenta" : "bg-gray-50"
      } relative flex h-[100px] flex-1 flex-col rounded px-2  py-1`}
      initial={{
        opacity: 0,
      }}
      animate={{
        opacity: 1,
      }}
      exit={{
        opacity: 0,
      }}
    >
      <h3
        className={`${
          props.type === "default" ? "text-gray-700" : isMagenta ? "text-white" : "text-gray-900"
        } text-xs`}
      >
        {props.title}
      </h3>
      <div className="mb-1 flex w-fit flex-col gap-2">
        <p className={"font-display text-4xl"}>{props.count}</p>
        {change && (
          <span
            className={`absolute right-2 top-1/2 -translate-y-1/2 rounded p-1 text-[10px] font-bold ${
              isGray ? "bg-gray-200 text-black" : "bg-white text-black"
            }`}
          >
            {change}%
          </span>
        )}
      </div>
      {props.rate ? (
        <p className={`${isMagenta ? "text-white" : "text-gray-900"} mt-auto text-xs`}>
          {props.rate}/100k people
        </p>
      ) : (
        <p className={`${isMagenta ? "text-white" : "text-gray-900"} mt-auto text-xs`}>
          in a 2 mile radius
        </p>
      )}
    </motion.div>
  );
}
